import { render } from "./movimentos-list-syncfusion.vue?vue&type=template&id=d45e8fda"
import script from "./movimentos-list-syncfusion.vue?vue&type=script&lang=js"
export * from "./movimentos-list-syncfusion.vue?vue&type=script&lang=js"

import "./movimentos-list-syncfusion.vue?vue&type=style&index=0&id=d45e8fda&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__